import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sempre que a rota (pathname) mudar, rola a página para o topo.
 * Resolve o problema de, ao clicar em "Home" (ou qualquer link do menu)
 * estando com scroll no meio de outra página, a nova página abrir
 * também no meio em vez de começar do topo.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
